module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_sand_1-2fca4db2118b159c019b2f7bf6d2ae41.png";